import { render, staticRenderFns } from "./ccBlockedSites.vue?vue&type=template&id=0f064a83"
import script from "./ccBlockedSites.vue?vue&type=script&lang=js"
export * from "./ccBlockedSites.vue?vue&type=script&lang=js"
import style0 from "./ccBlockedSites.vue?vue&type=style&index=0&id=0f064a83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports